export default __webpack_public_path__ + "static/media/FooterLogo.d1629c5a.svg";